import { Controller } from '@hotwired/stimulus';
import apiSolicitudMatricula from '@/api/cifra/solicitud_matricula';
import { emailsToClipboard } from '@/libs/cifra/clipboard';

/**
 * Se conecta a un botón y cuando hacen click consultamos los emails y los copiamos
 * en el portapapeles
 */
export default class extends Controller {
  connect() {
    this.element.addEventListener('click', async (e) => {
      e.preventDefault();

      const idsSolicitudes = [...document.querySelectorAll(this.element.dataset.selector)]
        .map((el) => el.value);

      const emails = await apiSolicitudMatricula.emails(idsSolicitudes);
      emailsToClipboard(emails);
    });
  }
}
